import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {SellableSizeSearchModel} from "../sellable-size-search.model";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-sellable-size-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(SellableSizeSingleSelectEditControlComponent),
        provideSearchModel(SellableSizeSearchModel)
    ]
})
export class SellableSizeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<SellableSizeSearchModel> {
    private _sizeGroupId: number;

    constructor(model: SellableSizeSearchModel, injector: Injector) {
        super(model, injector, "id", "label");
    }

    get sizeGroupId(): number {
        return this._sizeGroupId;
    }

    @Input()
    set sizeGroupId(value: number) {
        this._sizeGroupId = value;
        if (this._sizeGroupId != undefined) {
            this.model.filter["sellablesizegroupId"] = value;
            this.model.search();
        }
    }
}
